import { useState } from 'react';

const indexItems = [
  {
    id: 1,
    label: '91视频全集',
    count: '328部',
    img: 'https://readdy.ai/api/search-image?query=Professional%20cinematic%20movie%20collection%20collage%20with%20film%20reels%20and%20vintage%20cinema%20aesthetic%20warm%20amber%20lighting%20dark%20theater%20background%20artistic%20composition%20editorial%20style%20photography%20with%20soft%20shadows%20and%20rich%20textures&width=800&height=600&seq=index-91video&orientation=landscape',
  },
  {
    id: 2,
    label: '97视频专区',
    count: '256部',
    img: 'https://readdy.ai/api/search-image?query=Modern%20digital%20media%20library%20with%20sleek%20interface%20design%20elements%20glowing%20screens%20displaying%20film%20thumbnails%20dark%20sophisticated%20atmosphere%20with%20warm%20accent%20lights%20high-end%20editorial%20photography&width=800&height=600&seq=index-97video&orientation=landscape',
  },
  {
    id: 3,
    label: '51视频合集',
    count: '189部',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20of%20media%20player%20symbols%20and%20film%20elements%20floating%20in%20dark%20space%20warm%20golden%20particles%20cinematic%20atmosphere%20modern%20minimalist%20design%20aesthetic%20with%20soft%20lighting&width=800&height=600&seq=index-51video&orientation=landscape',
  },
  {
    id: 4,
    label: '热播电视剧',
    count: '412部',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20scene%20with%20large%20TV%20screen%20displaying%20vibrant%20colors%20warm%20ambient%20lighting%20comfortable%20modern%20interior%20cinematic%20wide%20shot%20editorial%20interior%20photography%20style&width=800&height=600&seq=index-tvshows&orientation=landscape',
  },
  {
    id: 5,
    label: '最新电影',
    count: '537部',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20cinema%20marquee%20with%20glowing%20neon%20letters%20in%20warm%20red%20and%20gold%20tones%20dark%20night%20atmosphere%20retro-modern%20fusion%20theater%20entrance%20cinematic%20photography%20with%20dramatic%20lighting&width=800&height=600&seq=index-movies&orientation=landscape',
  },
  {
    id: 6,
    label: '动漫番剧库',
    count: '294部',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20illustration%20style%20collage%20of%20colorful%20animation%20cells%20and%20manga%20panels%20warm%20vibrant%20color%20palette%20creative%20studio%20atmosphere%20soft%20diffused%20lighting%20editorial%20art%20photography&width=800&height=600&seq=index-anime&orientation=landscape',
  },
  {
    id: 7,
    label: '综艺娱乐汇',
    count: '165部',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20stage%20lighting%20and%20entertainment%20show%20atmosphere%20colorful%20spotlights%20on%20dark%20background%20warm%20golden%20and%20amber%20tones%20concert%20and%20performance%20energy%20editorial%20event%20photography&width=800&height=600&seq=index-variety&orientation=landscape',
  },
];

export default function IndexSection() {
  const [errors, setErrors] = useState<Record<number, boolean>>({});

  const handleError = (id: number) => {
    setErrors((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">专题合集</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">精选91视频、97视频、51视频等热门高清影视专题</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                {!errors[item.id] ? (
                  <img
                    src={item.img}
                    alt={item.label}
                    title={`神马视频 ${item.label}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => handleError(item.id)}
                  />
                ) : (
                  <div className="w-full h-full bg-background-200 flex items-center justify-center">
                    <i className="ri-image-line text-foreground-300 text-2xl"></i>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <span className="text-background-50 text-sm font-semibold">{item.label}</span>
                  <div className="flex items-center gap-1 mt-1">
                    <i className="ri-play-circle-line text-primary-400 text-xs"></i>
                    <span className="text-background-200/80 text-xs">{item.count}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}